import { render, staticRenderFns } from "./NumberLists.vue?vue&type=template&id=f4c40d24&scoped=true&"
import script from "./NumberLists.vue?vue&type=script&lang=ts&"
export * from "./NumberLists.vue?vue&type=script&lang=ts&"
import style0 from "./NumberLists.vue?vue&type=style&index=0&id=f4c40d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c40d24",
  null
  
)

export default component.exports